/* istanbul ignore file */

// Note that this is a .js file, not .ts, because it is imported by src/services/RedirectsManager/RedirectsManager.js, which is imported by next.config.js

const slugs = {
  // this is used for us to port over pay it forward subscriptions
  angelOldChosen: 'angel-old-chosen',
  afterDeath: 'after-death',
  angelGuild: 'angel-guild',
  angelStudios: 'angel-studios',
  aWeekAwaySeries: 'a-week-away-series',
  axiom: 'axiom',
  beyondTheMedal: 'beyond-the-medal',
  bonhoeffer: 'bonhoeffer',
  braveTheDark: 'brave-the-dark',
  cabrini: 'cabrini',
  contentGraveyard: 'content_graveyard',
  david: 'david',
  dryBar: 'dry-bar-best-of',
  fellowship: 'fellowship',
  forYourConsideration: 'for-your-consideration',
  forYourConsiderationStaging: 'for-your-consideration-staging',
  freelancers: 'freelancers',
  gabrielAndTheGuardians: 'gabriel-and-the-guardians',
  hisOnlySon: 'his-only-son',
  homestead: 'homestead',
  homesteadFamilySurvival: 'homestead-family-survival',
  insideAngelStudios: 'inside-angel-studios',
  jacob: 'jacob',
  jungleBeat: 'jungle-beat',
  lightwise: 'lightwise',
  liveNotByLies: 'live-not-by-lies',
  lostOnAMountainInMaine: 'lost-on-a-mountain-in-maine',
  operationTripleTake: 'operation-triple-take',
  playingForEternity: 'playing-for-eternity',
  possumTrot: 'possum-trot',
  quitters: 'quitters',
  redemptionOfHenryMyers: 'redemption-of-henry-myers',
  riot: 'riot',
  riotAndTheDanceSeries: 'riot-and-the-dance-series',
  sevenDaysInUtopia: 'seven-days-in-utopia',
  sight: 'sight',
  somebodysGottaDoIt: 'somebodys-gotta-do-it',
  somethingToStandForWithMikeRowe: 'something-to-stand-for-with-mike-rowe',
  soundOfFreedom: 'sound-of-freedom',
  soundOfHopeTheStoryOfPossumTrot: 'sound-of-hope-the-story-of-possum-trot',
  standingUp: 'standing-up',
  stagingForContent: 'staging-for-content',
  surprisedByOxford: 'surprised-by-oxford',
  sweetwater: 'sweetwater',
  telegram: 'telegram',
  tempest: 'tempest',
  testament: 'testament',
  testamentSeries: 'testament-series',
  the1916Project: '1916-project',
  theChosen: 'the-chosen',
  theGermanKing: 'the-german-king',
  theLastRodeo: 'the-last-rodeo',
  theShift: 'the-shift',
  theWay: 'the-way',
  toEndAllWars: 'to-end-all-wars',
  triumphOfTheHeart: 'triumph-of-the-heart',
  truthAndConviction: 'truth-and-conviction',
  tuttleTwins: 'tuttle-twins',
  twentyThreeBlast: '23-blast',
  wingfeatherSaga: 'wingfeather-saga',
  youngDavid: 'young-david',
  youngWashington: 'young-washington',
}

module.exports = {
  slugs,
}
